import { nullable } from '@infl-ts/util-io-ts';
import { Admin, ChallengeActivityTimelineEntry } from '@infl-ts/util-use-challenge-player';
import * as t from 'io-ts';
export var RejectedCorporateAlertEntry = t.intersection([ChallengeActivityTimelineEntry, t.type({
  __typename: t.literal('ActivityTimelineChallengeRejected'),
  admin: nullable(Admin),
  feedback: nullable(t.string)
})]);
export var NonRejectedCorporateAlertEntries = t.intersection([ChallengeActivityTimelineEntry, t.type({
  __typename: t.keyof({
    ActivityTimelineCorporateRedo: null,
    ActivityTimelineCorporateConfirmation: null,
    ActivityTimelineReceivedFeedback: null
  }),
  admin: nullable(Admin),
  feedback: nullable(t.string)
})]);